
import React, {useState} from "react";
import Info_Component from "../components/info";
import PhoneFieldComponent from "../components/phone";

function ForeignActivity_Section(props) {

    let symbol = props.rs;
    const data = props.data;

    return <div id={'ForeignActivity_Section'} className={''}>


        <div className="d-flex justify-content-between align-items-center mb-2">
            <Info_Component
                text={'"+" - додавання рядку; "-" - видалення рядку'}
            />

            <button onClick={props.handleInsertData} className={'btn btn-secondary rounded-3'}>
                +
            </button>
        </div>

        <div id="list-phones">
            <div key={1} className="d-flex justify-content-between align-items-center mt-1">

                <small className="text-muted m-1">
                    #1
                </small>

                <div id={'status'} className="d-flex flex-column">
                    <label htmlFor="">
                        Статус
                    </label>
                    <select className={'form-control'}>
                        <option value="">
                            Не перевірявся
                        </option>
                        <option value="">
                            Не території
                        </option>
                        <option value="">
                            В’їзд
                        </option>
                        <option value="">
                            Виїзд
                        </option>
                    </select>
                </div>

                <div className="date">
                    <label htmlFor="">
                        Дата
                    </label>
                    <input type="date" className={'form-control'} />
                </div>

                <div className={'country'}>
                    <label htmlFor="">
                        Країна
                    </label>
                    <input type="text" placeholder={'Україна'} className={'form-control'} />
                </div>

                <button
                        className={'btn btn-outline-danger rounded-3 m-1'}>
                    -
                </button>

            </div>
            {/*{*/}
            {/*    data.map((phone, i) => */}
            {/*        <div key={i} className="d-flex justify-content-between align-items-center mt-1">*/}

            {/*        <small className="text-muted m-1">*/}
            {/*            #{i + 1}*/}
            {/*        </small>*/}

            {/*        <PhoneFieldComponent*/}
            {/*            id={i}*/}
            {/*            value={phone}*/}
            {/*            onChange={props.handleChangeData}*/}
            {/*            add={props.handleInsertData}*/}
            {/*            placeholder={''}*/}
            {/*        />*/}

            {/*        <button onClick={() => props.handleRemoveData(i)}*/}
            {/*                className={'btn btn-outline-danger rounded-3 m-1'}>*/}
            {/*            -*/}
            {/*        </button>*/}

            {/*    </div>*/}
            {/*    )*/}
            {/*}*/}

        </div>
    </div>
}

export default ForeignActivity_Section;
